import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output} from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import { CONSTANTS } from 'src/app/constants';
import { PoTableColumn, PoTableDetail } from '@po-ui/ng-components';

@Component({
  selector: 'app-financial-account-balance',
  templateUrl: './financial-account-balance.component.html',
  styleUrls: ['./financial-account-balance.component.css']
})
export class FinancialAccountBalanceComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  loading: boolean = true;
  errorApi: boolean = false;
  listItem: Array<any> = [];
  loadingSaldoContas: boolean = true;
  message : string = "";
  columns: Array<PoTableColumn> = this.getColumns();
  totalExpanded = 0;

  constructor(private api: ApiService, @Inject(LOCALE_ID) public locale: string) { }

  ngOnInit(): void {
    this.getColumns();
  }

  filterItem(item: any) {
    this.listItem = [];
    this.errorApi = false;
    this.loading = true;
    this.payReceiveInformation(item);
  }

  payReceiveInformation(item: any) {
    this.api.postAccountBalance(item.dataMax, item.branch).subscribe(data => {
      try {
        if(data.dataRow != 0){
          const groupedData = data.dataRow.reduce((acc: any, data: any) => {
            const bankName = data.bank_name;
            if (!acc[bankName]) {
              acc[bankName] = [];
            }
            acc[bankName].push({
              agency: data.agency,
              account_bank: data.account_bank,
              value_balance_concilied: 'R$ ' + parseFloat(data.value_balance_concilied).toLocaleString('pt-br', { minimumFractionDigits: 2 })
            });
            return acc;
          }, {});
  
          this.listItem = Object.keys(groupedData).map(bankName => ({
            bank_name: bankName,
            detail: groupedData[bankName]
          }));

          this.listItem.sort((a: any, b: any) => -1 * b.bank_name.localeCompare(a.bank_name));
          this.errorApi = false;
        } else {
          this.errorApi = true;
          this.message = CONSTANTS.MESSAGES.DATA_NULL_ACCOUNT_BALANCE;
          this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_ACCOUNT_BALANCE);
        }
        this.loading = false;
      } catch (error : unknown) {
        this.loading = false;
        this.loadingSaldoContas = false;
        if (error instanceof Error)
          this.formatErrorMensagem(error.message);
      }
    }, error => {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_ACCOUNT_BALANCE;
      this.formatErrorMensagem(error.message);
    });
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: financial-account-balance \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

  getColumns(): Array<PoTableColumn> {
    const airfareDetail: PoTableDetail  = {
      columns: [
        { property: 'agency', label: 'Agência', type: 'string' },
        { property: 'account_bank', label: 'Conta', type: 'string'},
        { property: 'value_balance_concilied', label: 'Valor conciliado', type: 'string'}
      ],
      typeHeader: 'top'
    };

    return [
      { property: 'bank_name', label: 'Banco', type: 'string'},
      { property: 'detail', label: 'Details', type: 'detail', detail: airfareDetail }

    ];
  }  

  onCollapseDetail() {
    this.totalExpanded -= 1;
    this.totalExpanded = this.totalExpanded < 0 ? 0 : this.totalExpanded;
  }

  onExpandDetail() {
    this.totalExpanded += 1;
  }

}
